var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 283,
    viewBox: "0 0 217 283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.574 45.1201V282.37H180.324H184.164H216.874V249.65V45.1201H47.574Z",
    fill: "#080E04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0139 37.5601V274.81H172.764H176.604H209.314V242.09V37.5601H40.0139Z",
    fill: "#6CCA36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 30V267.25H164.75H168.59H201.3V234.53V30H32Z",
    fill: "#E8FFDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55 17H13V43H55V17Z",
    fill: "#080E04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8035 1H37.873L41.1949 1.00023C53.7626 1.00023 63.9984 11.4808 63.9984 24.4769V31.1368C63.9984 44.1323 53.7631 54.6054 41.1949 54.6054H23.8031H23.8016C21.0422 54.6097 18.3056 54.0983 15.7334 53.0979L15.1559 52.8733L14.6978 53.2904L4.07974 62.9563C2.85391 64.0727 2.1056 64.0609 1.81651 63.9271C1.5107 63.7855 1 63.1882 1 61.4945V32.9647C1 32.7862 1.00841 32.6158 1.02459 32.4443L1.0313 32.3732L1.02784 32.3019C1.00916 31.9164 1 31.5282 1 31.1366V24.4767C1 11.4804 11.2357 1 23.8035 1Z",
    fill: "#6CCA36",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 117.5C95.2673 117.149 70.0028 131.442 60.6696 137.172C58.8759 138.273 58.8483 140.769 60.6177 141.909C69.888 147.882 95.127 162.865 114.5 162.5C132.929 162.153 156.645 147.718 165.479 141.896C167.217 140.752 167.188 138.29 165.426 137.184C156.528 131.6 132.783 117.834 114.5 117.5Z",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.897 139.923C137.897 152.222 127.661 162.218 115 162.218C102.339 162.218 92.1026 152.222 92.1026 139.923C92.1026 127.625 102.339 117.628 115 117.628C127.661 117.628 137.897 127.625 137.897 139.923Z",
    stroke: "black",
    strokeWidth: 1.20513
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.14 128C114.186 128 113.246 128.112 112.353 128.335C115.052 129.226 117.009 131.765 117.009 134.749C117.009 138.476 113.975 141.509 110.248 141.509C107.252 141.509 104.714 139.553 103.834 136.854C103.611 137.745 103.5 138.674 103.5 139.64C103.5 146.066 108.726 151.28 115.14 151.28C121.554 151.28 126.78 146.055 126.78 139.64C126.78 133.226 121.554 128 115.14 128Z",
    fill: "#080E04"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 172,
    width: 1,
    height: 10,
    rx: 0.5,
    fill: "#080E04"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 142.5,
    y: 169.596,
    width: 1,
    height: 11.5336,
    rx: 0.5,
    transform: "rotate(-36.5802 142.5 169.596)",
    fill: "#080E04"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 11.5336,
    rx: 0.5,
    transform: "matrix(-0.803024 -0.595947 -0.595947 0.803024 91.1765 169.596)",
    fill: "#080E04"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 10,
    rx: 0.5,
    transform: "matrix(1 0 0 -1 115.5 109)",
    fill: "#080E04"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 11.5336,
    rx: 0.5,
    transform: "matrix(0.803024 0.595947 0.595947 -0.803024 142.5 111.404)",
    fill: "#080E04"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 91.1765,
    y: 111.404,
    width: 1,
    height: 11.5336,
    rx: 0.5,
    transform: "rotate(143.42 91.1765 111.404)",
    fill: "#080E04"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21,
    width: 37,
    height: 1,
    fill: "#080E04"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 26,
    width: 37,
    height: 1,
    fill: "#080E04"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 33,
    width: 24,
    height: 1,
    fill: "#080E04"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.935916c478507ff43cf7576614e05adb.svg";
export { ForwardRef as ReactComponent };